import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { setDrawer } from 'slices/drawer'
import { useFirebaseEvent } from 'hooks'
import './style.scss'

export function AINotFound({ event = '' }) {
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  function handleSearchAgain() {
    if (event) sendEvent(event)

    dispatch(setDrawer(DRAWER_KEY.FAQ))
  }

  return (
    <div className='ai-not-found-container'>
      <span className='title'>Não encontrou o que precisava?</span>
      <span className='subtitle'>Tente uma nova busca</span>
      <button type='button' onClick={handleSearchAgain} className='button'>
        Buscar novamente <STATICS.ARROW_NEXT />
      </button>
    </div>
  )
}
